const PARALLAX_SPEED = 0.35;

(function ($) {
  const updateParallaxEffect = (
    element,
    isSpecialImg = false,
    speed = PARALLAX_SPEED
  ) => {
    if (!element || element.length === 0) {
      return;
    }

    const windowHeight = $(window).height();
    const parallaxOffsetTop = element.offset().top;
    const parallaxHeight = element.outerHeight();
    const scrollPassed =
      $(window).scrollTop() - parallaxOffsetTop + windowHeight;

    if (scrollPassed >= 0 && scrollPassed <= parallaxHeight + windowHeight) {
      const percentVisible = scrollPassed / (parallaxHeight + windowHeight);
      const offset = percentVisible * parallaxHeight * speed;

      if (isSpecialImg) {
        element.css("top", `${-70 + offset}px`);
      } else {
        element.css("background-position", `0 ${offset}px`);
      }
    }
  };

  $(window).scroll(() => {
    $(".parallax-bg").each(function () {
      let parallaxSpeed = $(this).data("parallax-speed");
      parallaxSpeed = parallaxSpeed
        ? parseFloat(parallaxSpeed)
        : PARALLAX_SPEED;
      updateParallaxEffect($(this), false, parallaxSpeed);
    });

    updateParallaxEffect($(".custom-map .container-1170 img"), true);
  });
})(jQuery);
